import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { clientsData } from "../Data";

const slides = [
  { src: "./img/slider1.jpg", alt: "slide1" },
  { src: "./img/gall555.jpg", alt: "slide3" },
  { src: "./img/gall56.webp", alt: "slide2" },
];

const SliderArrow = ({ direction, onClick }) => (
  <button
    onClick={onClick}
    className={`absolute top-1/2 z-20 -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-40 border border-white/30 rounded-full p-3 shadow-lg transition-all duration-200 focus:outline-none ${
      direction === "left" ? "left-4" : "right-4"
    }`}
    aria-label={`${direction === "left" ? "Previous" : "Next"} slide`}
  >
    {direction === "left" ? (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    ) : (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    )}
  </button>
);

export const HomeSlider = () => {
  const slideTitles = [
    "Welcome to Adarsh Calibration LLP",
    "Precision Calibration Services",
    "Quality You Can Trust",
  ];

  const slideSubtitles = [
    "Your trusted partner for all calibration needs",
    "Serving industries with accuracy and reliability",
    "ISO/IEC 17025 accredited laboratory",
  ];

  const mainSliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SliderArrow direction="right" />,
    prevArrow: <SliderArrow direction="left" />,
  };

  return (
    <div className="w-full m-0 overflow-hidden relative">
      <Slider {...mainSliderSettings}>
        {slides.map((slide, idx) => (
          <div key={idx} className="relative h-[25rem] md:h-[35rem]">
            <img
              src={slide.src}
              alt={slide.alt}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-slate-800/70 to-slate-900/90 flex flex-col items-center justify-center text-white px-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 text-center">
                {slideTitles[idx]}
              </h1>
              <p className="text-lg md:text-xl text-slate-100 text-center max-w-3xl">
                {slideSubtitles[idx]}
              </p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

const CustomArrow = ({ className, style, onClick, direction }) => {
  return (
    <button
      className={`absolute top-1/2 z-20 -translate-y-1/2 bg-white bg-opacity-75 rounded-full p-2 shadow-md hover:bg-opacity-100 focus:outline-none ${
        direction === "left" ? "left-2" : "right-2"
      }`}
      style={{ ...style }}
      onClick={onClick}
      aria-label={`${direction} arrow`}
    >
      {direction === "left" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-gray-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-gray-700"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      )}
    </button>
  );
};

export const ClientSlider = () => {
  const settings = {
    dots: false, 
    infinite: true, 
    speed: 500, 
    slidesToShow: 4, 
    slidesToScroll: 1, 
    autoplay: true, 
    autoplaySpeed: 3000, 
    nextArrow: <CustomArrow direction="right" />, 
    prevArrow: <CustomArrow direction="left" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="bg-gray-50">
      {/* <div className="py-8 lg:py-16 mx-auto max-w-screen-xl px-4">
        <h2 className="font-extrabold mt-5 mb-10 uppercase leading-snug text-center text-blue-600 py-3 text-3xl md:text-4xl font-teko">
          Our Prestigious Clients
        </h2>

        <Slider {...settings} className="text-gray-400 gap-y-6">
          {clientsData.map((client) => (
            <div
              key={client.id}
              className="flex justify-center items-center flex-col gap-4"
            >
              <img
                src={client.imageSrc}
                alt={`client${client.id}`} // Fixed the alt attribute
                className="h-48 w-[90%] object-contain border-2 border-blue-200 rounded-xl px-5 mx-2 shadow-md hover:shadow-lg transition-all" // Added mx-2 for left and right gap
              />
            </div>
          ))}
        </Slider>
      </div> */}
    </section>
  );
};
